import { z } from 'zod'
import {
  workerClassifications,
  WorkerClassification,
} from 'constants/workerClassification'

const workerClassificationIds = workerClassifications.map((c) => c.id) as [
  WorkerClassification,
  ...WorkerClassification[],
]

export const filtersSchema = z.object({
  user: z.object({
    userId: z.number().nullable(),
  }),
  shiftId: z.object({
    id: z.number().nullable(),
  }),
  companyId: z.object({
    id: z.number().nullable(),
  }),
  status: z.object({
    statuses: z.array(z.string()),
  }),
  workerClassification: z.object({
    values: z.array(z.enum(workerClassificationIds)),
  }),
  completedDaysAgo: z.object({
    days: z.coerce.number().nullable(),
  }),
})

export type FiltersSchema = z.infer<typeof filtersSchema>
